import React from 'react';
import { Grid } from '@material-ui/core';
import { EntityAboutCard, EntityLayout } from '@backstage/plugin-catalog';

export const entityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item md={6} xs={12}>
          <EntityAboutCard variant="gridItem" />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
